const reviews = {
  top_reviews: [
    {
      id: 0,
      date_created: '2024-04-01T12:00:00.00Z',
      public_review: 'review--0--review',
      user: {
        first_name: 'Latrice',
        last_name: 'P',
        has_photo: false,
      },
      rating: 5,
      listing_headline: 'review--0--headline',
    },
    {
      id: 1,
      date_created: '2023-05-01T12:00:00.00Z',
      public_review: 'review--1--review',
      user: {
        first_name: 'Ali',
        last_name: 'M',
        has_photo: false,
      },
      rating: 5,
      listing_headline: 'review--1--headline',
    },
    {
      id: 2,
      date_created: '2023-08-01T12:00:00.00Z',
      public_review: 'review--2--review',
      user: {
        first_name: 'Susie',
        last_name: 'G',
        has_photo: false,
      },
      rating: 5,
      listing_headline: 'review--2--headline',
    },
    {
      id: 3,
      date_created: '2024-02-01T12:00:00.00Z',
      public_review: 'review--3--review',
      user: {
        first_name: 'Mike',
        last_name: 'T',
        has_photo: false,
      },
      rating: 5,
      listing_headline: 'review--3--headline',
    },
    {
      id: 4,
      date_created: '2022-07-01T12:00:00.00Z',
      public_review: 'review--4--review',
      user: {
        first_name: 'Michaela',
        last_name: 'S',
        has_photo: false,
      },
      rating: 5,
      listing_headline: 'review--4--headline',
    },
    {
      id: 5,
      date_created: '2022-08-01T12:00:00.00Z',
      public_review: 'review--5--review',
      user: {
        first_name: 'Ihaly',
        last_name: 'M',
        has_photo: false,
      },
      rating: 5,
      listing_headline: 'review--5--headline',
    },
  ],
};

export default reviews;
